import React, { useState } from 'react';
import { contributorRowAvatarUrl } from '../../utils/githubAvatarUrl';
import { memberAvatarBorder } from '../members/memberViewTheme';

const sizePx = { xxs: 20, xs: 28, sm: 32, md: 40 };
const sizeClass = {
  xxs: 'h-5 w-5 text-[9px]',
  xs: 'h-7 w-7 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
};

/**
 * GitHub (or stored) avatar for a contributor analytics row; letter fallback when no URL.
 * @param {{ row: Record<string, unknown>, size?: 'xxs'|'xs'|'sm'|'md', className?: string }} props
 */
export default function ContributorRowAvatar({ row, size = 'sm', className = '' }: any) {
  const [failed, setFailed] = useState(false);
  const src = contributorRowAvatarUrl(row);
  const label =
    String(row.displayName || row.name || row.github || row.email || '').trim() || 'Contributor';
  const initial = (label[0] || '?').toUpperCase();
  const dim = sizePx[size] || sizePx.sm;
  const box = `${sizeClass[size] || sizeClass.sm} inline-flex shrink-0 items-center justify-center rounded-full`;

  if (!src || failed) {
    return (
      <span className={`${box} bg-vivid-purple font-semibold text-white ${className}`} aria-hidden>
        {initial}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      width={dim}
      height={dim}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
      className={`${box} object-cover bg-dark-elevated ${memberAvatarBorder} ${className}`}
      onError={() => setFailed(true)}
    />
  );
}
